import { types } from "../types/types";

const initialState = {
  catalogRole: {},
  catalogRoles: [],
  catalogRolesP: [],
  catalogRolesS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
};
export const catalogRoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CATALOGROLE_SELECT:
      return {
        ...state,
        catalogRole: action.payload,
      };

    case types.CATALOGROLE_UPDATE:
      if (state.catalogRolesS.length > 0) {
        return {
          ...state,
          catalogRolesS: state.catalogRolesS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          catalogRolesP: state.catalogRolesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          catalogRolesP: state.catalogRolesP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.CATALOGROLE_DELETE:
      if (state.catalogRolesS.length > 0) {
        return {
          ...state,
          catalogRolesS: state.catalogRolesS.filter((usr) => usr.id !== action.payload),
          catalogRolesP: state.catalogRolesP.filter((usr) => usr.id !== action.payload),
          catalogRole: {},
        };
      } else {
        return {
          ...state,
          catalogRolesP: state.catalogRolesP.filter((usr) => usr.id !== action.payload),
          catalogRole: {},
        };
      }

    case types.CATALOGROLE_START_LOADING:
      
      return {
        ...state,
        catalogRoles: action.payload,
      };

    case types.CATALOGROLE_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogRolesP: action.payload.catalogRolesP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CATALOGROLE_START_SEARCH:
      return {
        ...state,
        catalogRolesS: action.payload,
      };

    case types.CATALOGROLE_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogRolesS: action.payload.catalogRolesP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CATALOGROLE_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogRolesS: [],
      };

    case types.CATALOGROLE_CLEAN:
      return {
        ...state,
        catalogRole: {},
      };

    case types.CATALOGROLE_START_REGISTER:
      return {
        ...state,
        catalogRole: action.payload,
      };

    case types.CATALOGROLE_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    default:
      return state;
  }
};
